import { getHTTPProtocol } from '@epihub/core/src/process/protocols';
import { getAppDomains } from '@krishanmadan/core/src/_ctx/vars';

export function downloadCVProgrammatically() {
  const downloadUrl = `${getHTTPProtocol()}//${getAppDomains().backend}/user/cv`;
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = 'Krishan_Marco_Madan_CV.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
